export { AuthState } from './auth/auth.state';
export { CreditsState } from './credits/credits.state';
export { CountriesState } from './countries/countries.state';
export { ProfileState } from './profile/profile.state';
export { NotificationState } from './notifications/notifications.state';
export { InvitationsState } from './invitations/invitations.state';
export { VacancyState } from './vacancy/vacancy.state';
export { BillingState } from './billing/billing.state';
export { CompanyState } from './company/company.state';

import { AuthState } from './auth/auth.state';
import { CreditsState } from './credits/credits.state';
import { CountriesState } from './countries/countries.state';
import { ProfileState } from './profile/profile.state';
import { NotificationState } from './notifications/notifications.state';
import { InvitationsState } from './invitations/invitations.state';
import { VacancyState } from './vacancy/vacancy.state';
import { BillingState } from './billing/billing.state';
import { CompanyState } from './company/company.state';

export const appState = [
  AuthState,
  CreditsState,
  CountriesState,
  ProfileState,
  NotificationState,
  InvitationsState,
  VacancyState,
  BillingState,
  CompanyState,
];
